import { createSlice } from '@reduxjs/toolkit';

import type { PartesState } from '@/types/processos/parteStoreTypes';

import {
  atualizarOrdemParte,
  atualizarParte,
  criarParte,
  listarPartes,
  removerParte,
} from './actions';

const initialState: PartesState = {
  itens: [],
  carregando: false,
  erro: null,
};

const partesSlice = createSlice({
  name: 'partes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listarPartes.pending, (state) => {
        state.carregando = true;
        state.erro = null;
      })
      .addCase(listarPartes.fulfilled, (state, action) => {
        state.carregando = false;
        state.itens = action.payload;
      })
      .addCase(listarPartes.rejected, (state, action) => {
        state.carregando = false;
        state.erro = (action.payload as string) || action.error.message || 'Erro ao listar partes';
      })
      .addCase(criarParte.fulfilled, (state, action) => {
        state.itens = [action.payload, ...state.itens];
      })
      .addCase(atualizarParte.fulfilled, (state, action) => {
        state.itens = state.itens.map((p) => (p.id === action.payload.id ? action.payload : p));
      })
      .addCase(atualizarOrdemParte.fulfilled, (state, action) => {
        state.itens = state.itens.map((p) => (p.id === action.payload.id ? action.payload : p));
      })
      .addCase(removerParte.fulfilled, (state, action) => {
        state.itens = state.itens.filter((p) => p.id !== action.payload);
      });
  },
});

export const partesReducer = partesSlice.reducer;
